import { any, z } from "zod";

 
const MembershipSchema = z.object({
  membershipId: z.number().nullable(),
  membershipName: z.string().nullable(),
 
});
const permissions = z.object({
  customers: z.number(),
  suppliers: z.number(),
  transport: z.number(),
});
 

const MainSchema = z.object({
 
  membershiplist: z.array(MembershipSchema).nullable(),
  permissions : permissions,
  typeOfContact: z.string().nullable(),
  customerCategoryList: any().nullable(),
});

export type MemberType = z.infer<typeof MembershipSchema>;
export type MainType = z.infer<typeof MainSchema>;
export default MainSchema;



// contact Detail

const SettingSchema = z.object({
  companySettingId: z.number().nullable(),
  value: z.number().nullable(),
  addValue: z.any().nullable(),
  type: z.string().nullable(),
  companyId: z.number().nullable(),
  branchId: z.number().nullable(),
  userId: z.number().nullable(),
  lastSynced: z.any().nullable(),
});

const ContactAddressSchema = z.object({
  countriesName: z.string().nullable(),
  stateName: z.string().nullable(),
  cityName: z.string().nullable(),
  localityName: z.string().nullable(),
  contactAddressId: z.number().nullable(),
  contactCompanyName: z.string().nullable(),
  nameTitle: z.string().nullable(),
  addressType: z.string().nullable(),
  contactFirstName: z.string().nullable(),
  contactLastName: z.string().nullable(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  addressLine3: z.string().nullable(),
  countriesCode: z.string().nullable(),
  zoneCode: z.string().nullable(),
  stateCode: z.string().nullable(),
  cityCode: z.string().nullable(),
  localityCode: z.string().nullable(),
  place: z.string().nullable(),
  lat: z.number().nullable(),
  lng: z.number().nullable(),
  pinCode: z.string().nullable(),
  phoneNo: z.string().nullable(),
  email: z.string().nullable(),
  alternatePhoneNo: z.string().nullable(),
  isDeleted: z.number().nullable(),
  isDefault: z.number().nullable(),
  GSTIN: z.string().nullable(),
  gstType: z.string().nullable(),
  panNo: z.string().nullable(),
  pan: z.string().nullable(),
  landMark: z.string().nullable(),
  countryDialCodePrefix: z.number().nullable(),
});

const AccountGroupSchema: z.ZodSchema = z.object({
  accountGroupId: z.number().nullable(),
  accountGroupName: z.string().nullable(),
  groupType: z.string().nullable(),
  parentGroupVo: z.lazy(() => AccountGroupSchema).nullable(),
  groupNature: z.string().nullable(),
  isDeleted: z.number().nullable(),
  isDefault: z.number().nullable(),
  level: z.number().nullable(),
  companyId: z.number().nullable(),
  branchId: z.number().nullable(),
  alterBy: z.number().nullable(),
  createdBy: z.number().nullable(),
  createdOn: z.string().nullable(),
  modifiedOn: z.string().nullable(),
});

const AccountCustomSchema = z.object({
  accountCustomId: z.number().nullable(),
  group: AccountGroupSchema.nullable(),
  companyId: z.number().nullable(),
  branchId: z.number().nullable(),
  alterBy: z.number().nullable(),
  createdBy: z.number().nullable(),
  accountName: z.string().nullable(),
  name: z.string().nullable(),
  keyword: z.string().nullable(),
  companyName: z.string().nullable(),
  mobileNo: z.string().nullable(),
  isDeleted: z.number().nullable(),
  isUpdatable: z.number().nullable(),
  accounType: z.string().nullable(),
  createdOn: z.string().nullable(),
  modifiedOn: z.string().nullable(),
});

const ContactDetailsSchema = z.object({
  contactId: z.number().nullable(),
  companyName: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  mobNo: z.string().nullable(),
  telephone: z.string().nullable(),
  email: z.string().nullable(),
  dateOfBirth: z.any().nullable(),
  anniversaryDate: z.any().nullable(),
  gstin: z.any().nullable(),
  transporterId: z.any().nullable(),
  vatNo: z.any().nullable(),
  shopifySync: z.number().nullable(),
  associatedmerchant: z.number().nullable(),
  customerCategoryId: z.number().nullable(),
  customerCategoryName: z.any().nullable(),
  shopifySourceId: z.number().nullable(),
  panNo: z.any().nullable(),
  tanNo: z.any().nullable(),
  bankAcNo: z.any().nullable(),
  bankName: z.any().nullable(),
  bankBranch: z.any().nullable(),
  bankIfsc: z.any().nullable(),
  contactType: z.string().nullable(),
  type: z.string().nullable(),
  acceptMarketing: z.number().nullable(),
  note: z.any().nullable(),
  tag: z.any().nullable(),
  branchId: z.number().nullable(),
  companyId: z.number().nullable(),
  alterBy: z.number().nullable(),
  createdBy: z.number().nullable(),
  isDeleted: z.number().nullable(),
  active: z.number().nullable(),
  createdOn: z.string().nullable(),
  modifiedOn: z.string().nullable(),
  gstType: z.string().nullable(),
  creditDays: z.any().nullable(),
  creditLimit: z.any().nullable(),
  instruction: z.any().nullable(),
  imgLocation: z.any().nullable(),
  credit: z.number().nullable(),
  debit: z.number().nullable(),
  contactAddressVos: z.array(ContactAddressSchema).nullable(),
  accountCustomVo: AccountCustomSchema.nullable(),
  paymentMasterVo: z.any().nullable(),
  paymentTermVo: z.any().nullable(),
  memberShipMasterVo: z.any().nullable(),
  fromMemeberShipDate: z.any().nullable(),
  toMemeberShipDate: z.any().nullable(),
  isFeedbackGiven: z.number().nullable(),
  whatsappNo: z.string().nullable(),
  wooCommerceCustomerId: z.number().nullable(),
  remark: z.any().nullable(),
  code: z.any().nullable().optional(),
  supplierCode: z.any().nullable().optional(),
  memberShipNo: z.number().nullable(),
  walletBalance: z.number().nullable(),
  commission: z.number().nullable(),
  preLoadingPoint: z.number().nullable(),
  createdby_name: z.any().nullable(),
  dueAmount: z.any().nullable(),
  opening: z.any().nullable(),
  debitAmount: z.any().nullable(),
  creditAmount: z.any().nullable(),
  otp: z.any().nullable(),
  password: z.any().nullable(),
  tempotp: z.any().nullable(),
  clientCustomerId: z.any().nullable(),
  brnNo: z.any().nullable(),
  jpmCustomerId: z.number().nullable(),
  jpmIsCustomerVerified: z.number().nullable(),
  jpmcCDStatus: z.number().nullable(),
  isdefault: z.number().nullable(),
  isBranch: z.number().nullable(),
  accountGroupId: z.number().nullable(),
  isMobNoVerify: z.number().nullable(),
  accountGroupName: z.string().nullable(),
  countryDialCodePrefix: z.number().nullable(),
  countryDialCodePrefixWhatsapp: z.number().nullable(),
  outstanding: z.number().nullable(),
  acNo: z.any().nullable(),
  pan: z.any().nullable(),
  isVerified: z.number().nullable(),
  name: z.any().nullable(),
  existInTransaction: z.boolean().nullable(),
});

const CityListSchema = z.object({
  cityId: z.number().nullable(),
  cityCode: z.string().nullable(),
  cityName: z.string().nullable(),
  stateCode: z.string().nullable(),
  countriesCode: z.string().nullable(),
  zoneCode: z.any().nullable(),
});

const CountryListSchema = z.object({
  countriesId: z.number().nullable(),
  countriesCode: z.string().nullable(),
  countriesName: z.string().nullable(),
  currencyCode: z.string().nullable(),
  currencyName: z.string().nullable(),
  currencySymbol: z.string().nullable(),
  isbrnrequired: z.number().nullable(),
  countryDialCodePrefix: z.number().nullable(),
  countryImageName: z.string().nullable(),
});

const StateListSchema = z.object({
  stateId: z.number().nullable(),
  stateCode: z.string().nullable(),
  wooCommerceStateCode: z.string().nullable(),
  stateName: z.string().nullable(),
  countriesCode: z.string().nullable(),
  zoneCode: z.any().nullable(),
});

export const ContactDetailsRelatedSchema = z.object({
  totalAndpaidAmount: z.array(
    z.object({
      paidAmount: z.number().nullable(),
      totalamount: z.number().nullable(),
    })
  ).nullable(),
  expenseapproval: SettingSchema.nullable(),
  isView: z.number().nullable(),
  "view-name": z.string().nullable(),
  membership: SettingSchema.nullable(),
  type: z.string().nullable(),
  vat : z.string().nullable().optional(),
  createdOn: z.string().nullable(),
  ContactDetails: (ContactDetailsSchema).nullable(),
  CityList: z.array(CityListSchema).nullable(),
  CountryList: z.array(CountryListSchema).nullable(),
  allowfeedback: z.number().nullable(),
  isInsert: z.number().nullable(),
  notallowcontactdeleteofoutstandingavailable: SettingSchema.nullable(),
  outstanding: z.number().nullable(),
  isDelete: z.number().nullable(),
  actionBtnShow: z.number().nullable(),
  displayContactType: z.string().nullable(),
  allowsupplierwiseproductmapping: z.number().nullable(),
  feedBackPermission: z.number().nullable(),
  StateList: z.array(StateListSchema).nullable(),
  allowcustomerwiseproductmapping: z.number().nullable(),
  multibarcode: z.number().nullable().optional(),
  multiduplicatebarcode: z.number().nullable().optional(),
  isEdit: z.number().nullable(),
  loyalty: z.number().nullable(),
  allowb2b: SettingSchema.nullable(),
});

export type ContactDetailsRelatedSchema = z.infer<typeof ContactDetailsRelatedSchema>;
export type ContactAddressSchema =  z.infer<typeof ContactAddressSchema>

